import { render } from "./NewMessageComposer.vue?vue&type=template&id=362d345d&scoped=true"
import script from "./NewMessageComposer.vue?vue&type=script&lang=js"
export * from "./NewMessageComposer.vue?vue&type=script&lang=js"

import "./NewMessageComposer.vue?vue&type=style&index=0&id=362d345d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362d345d"]])

export default __exports__